import BigImageOverlay from "./BigImageOverlay";
import BigVideoOverlay from "./BigVideoOverlay";
import { BoothBlogPostDisplay } from "../../../shared/interfaces";
import BlogPostOverlay from "./BlogPostOverlay";

class InteractionPopup {
  domElement: HTMLElement;
  buttonElement: HTMLElement;
  textElement: HTMLElement;

  constructor() {
  }

  init() {
    this.domElement = document.getElementById('interactionPopup');
    this.buttonElement = this.domElement.querySelector('button');
    this.textElement = this.domElement.querySelector('p');

    BigVideoOverlay.init();
    BigImageOverlay.init();
    BlogPostOverlay.init();
  }

  show(description: string, buttonText: string, onInteract: Function) {
    if (
        this.domElement.style.display !== 'flex' ||
        this.buttonElement.innerText !== buttonText ||
        this.textElement.innerText !== description
    ) {
      this.domElement.style.display = 'flex';
      this.buttonElement.onclick = () => onInteract();
      this.buttonElement.innerText = buttonText
      this.textElement.innerText = description
    }
  }

  hide() {
    this.domElement.style.display = 'none';
    this.buttonElement.onclick = null;
    this.buttonElement.innerText = ""
    this.textElement.innerText = ""
  }

  showInteractionPopup(objectToInteract: any) {
    switch (objectToInteract.type) {
      case 'IMAGE':
        this.showImageInteractionPopup(objectToInteract.url)
        break;
      case 'VIDEO':
        this.showVideoInteractionPopup(objectToInteract.url)
        break;
      case 'LINK':
        this.showLinkInteractionPopup(objectToInteract.url, objectToInteract.description)
        break;
      case 'POST':
        this.showBlogPostInteractionPopup(objectToInteract )
        break;
      default:
        break;
    }
  }

  showImageInteractionPopup(url: string) {
    this.show(
        'Willst du dir dieses Bild genauer anschauen?',
        'Bild vergrößern!',
        () => BigImageOverlay.show(url)
    );
  }

  showLinkInteractionPopup(url: string, description?: string) {
    this.show(
        description || 'Willst du mehr über den Aussteller erfahren?',
        'Website öffnen!',
        () => window.open(url)
    );
  }

  showVideoInteractionPopup(url: string) {
    this.show(
        'Willst du dir dieses Video anschauen?',
        'Video starten!',
        () => BigVideoOverlay.show(url)
    );
  }

  showBlogPostInteractionPopup(post: BoothBlogPostDisplay) {
    this.show(
        'Willst du dir diesen Blogpost anschauen?',
        'Blogpost anschauen!',
        () => BlogPostOverlay.show(post)
    );
  }
}

export default new InteractionPopup();
